import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors, retrieveSession } from 'state';

/** Rare committed lifecycle changes reuse full hydration, without polling. */
export function useLiveBondRefresh(sessionId: number) {
  const dispatch = useDispatch();
  const session = useSelector(selectors.activeSession);
  const revision = session?.id === sessionId ? session.live_bond_revision ?? 0 : 0;
  const previous = useRef({ sessionId, revision });
  useEffect(() => {
    if (previous.current.sessionId === sessionId && revision > previous.current.revision) {
      dispatch(retrieveSession({ id: sessionId }));
    }
    previous.current = { sessionId, revision };
  }, [dispatch, sessionId, revision]);
}
